(function () {
  function slugify(text, used) {
    var base = text
      .toLowerCase()
      .trim()
      .replace(/[^a-z0-9]+/g, '-')
      .replace(/(^-|-$)/g, '');
    if (!base) base = 'section';
    var id = base;
    var n = 1;
    while (used[id]) {
      id = base + '-' + n;
      n++;
    }
    used[id] = true;
    return id;
  }

  function initToc() {
    var contentEl = document.querySelector('.article-single-content-wrap');
    var tocContainers = document.querySelectorAll('[data-article-toc]');
    if (!contentEl || !tocContainers.length) return;

    var headings = contentEl.querySelectorAll('h2');
    if (!headings.length) return;

    var used = {};
    var items = [];

    for (var i = 0; i < headings.length; i++) {
      var h = headings[i];
      var text = h.textContent.trim();
      if (!h.id) {
        h.id = slugify(text, used);
      } else {
        used[h.id] = true;
      }
      items.push({ id: h.id, text: text, index: i + 1 });
    }

    tocContainers.forEach(function (container) {
      var list = container.querySelector('[data-toc-list]');
      if (!list) return;

      items.forEach(function (item) {
        var li = document.createElement('li');
        li.className = 'sidebar-toc-item';

        var a = document.createElement('a');
        a.href = '#' + item.id;
        a.className = 'sidebar-toc-link';
        a.setAttribute('data-toc-target', item.id);

        var num = document.createElement('span');
        num.className = 'sidebar-toc-num';
        num.textContent = (item.index < 10 ? '0' : '') + item.index;

        var label = document.createElement('span');
        label.className = 'sidebar-toc-label';
        label.textContent = item.text;

        a.appendChild(num);
        a.appendChild(label);
        li.appendChild(a);
        list.appendChild(li);
      });

      container.classList.add('has-items');
    });

    var allLinks = document.querySelectorAll('[data-toc-target]');

    allLinks.forEach(function (link) {
      link.addEventListener('click', function (e) {
        e.preventDefault();
        var target = document.getElementById(link.getAttribute('data-toc-target'));
        if (!target) return;
        var top = target.getBoundingClientRect().top + window.pageYOffset - 100;
        window.scrollTo({ top: top, behavior: 'smooth' });
      });
    });

    if ('IntersectionObserver' in window) {
      var observer = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var id = entry.target.id;
              allLinks.forEach(function (l) {
                l.classList.toggle('is-active', l.getAttribute('data-toc-target') === id);
              });
            }
          });
        },
        { rootMargin: '-20% 0px -70% 0px' }
      );

      for (var j = 0; j < headings.length; j++) {
        observer.observe(headings[j]);
      }
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initToc);
  } else {
    initToc();
  }
})();
